export default function Floppy({ label = "XR_BUILD_014.unity", tilt = 2, size = "140px" }) {
  return (
    <div
      className="motif-floppy"
      style={{
        width: size,
        height: size,
        transform: `rotate(${tilt}deg)`,
      }}
    >
      <div className="shutter"></div>
      <div className="label">{label}</div>
      <div className="write-protect"></div>
    </div>
  );
}
